/**
 * Opens the path `load` resolves to in a new browser tab.
 *
 * The tab is opened before `load` runs, inside the click: browsers block a tab opened after an await as a popup. It
 * starts blank and is sent to the path once `load` returns one, or closed when it returns nothing or throws. When the
 * browser blocks the tab anyway, `fallback` runs instead, so the action still happens in the current tab.
 */
export async function openInNewTab(load: () => Promise<string | null>, fallback: () => Promise<unknown>): Promise<void> {
  const tab = window.open("", "_blank");
  if (!tab) {
    await fallback();
    return;
  }
  tab.opener = null;
  let path: string | null = null;
  try {
    path = await load();
  } finally {
    if (path) {
      tab.location.href = new URL(path, window.location.origin).href;
    } else {
      tab.close();
    }
  }
}
